import { Typography } from "@mui/material";
import GridKeikkaEditor_Teksti_Row from "../../teksti/GridKeikkaEditor_Teksti_Row";

export default function GridKeikkaEditor_Teksti_Tehdas({ subText, keikkaState }) {
  <GridKeikkaEditor_Teksti_Row title="Tehdas" gray phone={keikkaState.betoniSijaintiPhone}>
    {subText(keikkaState.betoniAsiakasNimi + " " + keikkaState.betoniSijaintiNimi)}
    <Typography variant="body2" color="secondary">
      {subText(keikkaState.betoniSijaintiOsoite1 + ", " + keikkaState.betoniSijaintiOsoite2)}
    </Typography>
  </GridKeikkaEditor_Teksti_Row>;
}
